/**
 * 本会话内已删除的 goal id 登记表。
 *
 * 后端 goal 索引「写后可见」有延迟（同一原因让 `scheduleGoalPlanInvalidation` 要延迟 1s 才 invalidate）：
 * 删除成功后立刻重新拉列表，拿回来的仍可能是含该 goal 的旧数据，又被 react-query 按 30s staleTime
 * 缓存下来 —— 表现就是「删完回 My goals 还在，要反复切 tab 才消失」。
 * 所以客户端记一笔：已删的 goal id 一律从任何 goal 列表结果里剔掉，不依赖后端何时收敛。
 */
const deletedGoalIds = new Set<string>();

export function markGoalDeleted(goalId: string): void {
  const id = goalId?.trim();
  if (id) {
    deletedGoalIds.add(id);
  }
}

export function isGoalDeleted(goalId?: string | null): boolean {
  return !!goalId && deletedGoalIds.has(goalId);
}

/** 从任意 goal 列表里剔除已删除的条目（无删除记录时原样返回，避免多余的数组拷贝）。 */
export function filterDeletedGoals<T extends { id?: string }>(rows: T[]): T[] {
  if (deletedGoalIds.size === 0) {
    return rows;
  }
  return rows.filter((row) => !isGoalDeleted(row.id));
}

/** 仅供测试重置登记表。 */
export function resetDeletedGoalsForTest(): void {
  deletedGoalIds.clear();
}
